import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { Button } from 'sarsaparilla';

const CONTINUE_TEXT = 'I Agree';
const CANCEL_TEXT = 'Cancel';

class ClickwrapModal extends React.Component {
  static propTypes = {
    shouldPresent: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onContinue: PropTypes.func.isRequired
  };

  static defaultProps = {
    shouldPresent: false
  };

  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.shouldPresent}
          onRequestClose={this.onModalCancel}
          role="complementary"
          className={{
            base: 'rec-modal-dialog-base',
            afterOpen: 'rec-modal-dialog-after-open-md',
            beforeClose: 'rec-modal-dialog-before-close'
          }}
          overlayClassName={{
            base: 'rec-overlay-base',
            afterOpen: 'rec-overlay-after-open',
            beforeClose: 'rec-overlay-before-close'
          }}
          contentLabel="You are exiting Recreation.gov"
          ariaHideApp={false}>
          <div>
            <div className="rec-modal-content-wrap">
              <h4 className="rec-modal-title">Agreement</h4>
              <p>
                <strong>
                  By requesting an apikey, you are agreeing to the&nbsp;
                  <a target="_blank" href="/ridb-access-agreement" rel="noopener noreferrer">
                    RIDB API Access Agreement.
                  </a>
                </strong>
              </p>
            </div>
            <div className="rec-modal-actions-wrap">
              <Button
                appearance="tertiary"
                title={CANCEL_TEXT}
                aria-label={CANCEL_TEXT}
                onClick={this.props.onCancel}>
                {CANCEL_TEXT}
              </Button>
              <Button
                title={CONTINUE_TEXT}
                aria-label={CONTINUE_TEXT}
                onClick={this.props.onContinue}>
                {CONTINUE_TEXT}
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default ClickwrapModal;
